import {
  ArticleImage,
  ArticleImageProps,
} from '@bonniernews/dn-design-system-web/assets/article-image/article-image.tsx'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/article-body-image](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/article-body-image)
 * - Storybook: [ArticleBodyImage](https://designsystem.dn.se/?path=/docs/article-articlebodyimage--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/article-body-image/article-body-image.scss'`
 */
export const ArticleBodyImage = ({
  image,
  caption = '',
  author = '',
  imageType = '',
  fullWidth,
  forcePx,
  classNames,
  attributes,
}: ArticleImageProps) => {
  const componentClassName = 'ds-article-image--body'
  const classes = formatClassString([componentClassName, classNames])

  return (
    <ArticleImage
      image={image}
      caption={caption}
      author={author}
      imageType={imageType}
      fullWidth={fullWidth}
      forcePx={forcePx}
      classNames={classes}
      attributes={attributes}
    />
  )
}
